import PrivateModal from '$lib/components/Modal/_PrivateModal.svelte';
import PrivateModalBackButton from '$lib/components/Modal/_PrivateModalBackButton.svelte';

export const Modal = Object.assign(PrivateModal, {
	BackButton: PrivateModalBackButton,
});
